import axios from 'axios';
import { getCSRFToken } from './csrf';

export async function cancelSubscription() {
  try {
    const csrfToken = getCSRFToken();
    
    const response = await axios.post('/api/billing/subscription/cancel/', {}, {
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json',
        ...(csrfToken && { 'X-CSRFToken': csrfToken })
      }
    });

    console.log('Subscription cancelled:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error cancelling subscription:', error);
    return null;
  }
}
